import { createFeatureSelector, createSelector } from '@ngrx/store';
import { featureKey, usersAdapter, UsersEntityState } from './users.reducer';

const { selectAll, selectEntities, selectIds } = usersAdapter.getSelectors();

const selectUsersState = createFeatureSelector<UsersEntityState>(featureKey);

export const selectUsersList = createSelector(selectUsersState, (state) => selectAll(state));
export const selectUsersMap = createSelector(selectUsersState, (state) => selectEntities(state));
export const selectUsersIds = createSelector(selectUsersState, (state) => selectIds(state));
export const selectLoading = createSelector(selectUsersState, (state) => state.loading);
export const selectLoaded = createSelector(selectUsersState, (state) => state.loaded);
export const selectPageParams = createSelector(selectUsersState, (state) => state.pageParams);
export const selectTotalElements = createSelector(selectUsersState, (state) => state.totalElements);
